/* One-time Shopify flow guard for this product. Cache-safe live revision 20260812-r5-speed-final.
   The old copied Kaching markup carried a subscription plan and bundle payload from another
   store. Shopify has no selling-plan group on this product, so preserve the native product form
   and remove those stale fields before the app can submit them. */
(function () {
  var PRODUCT_ID = '9599642140899';
  var VARIANTS = {
    '49522223186147': { price: '$8', compare: '$29.99' },
    '49522223218915': { price: '$8', compare: '$29.99' },
    '49522223251683': { price: '$11', compare: '$59.99' }
  };

  function onTargetProduct() {
    return document.body && document.body.getAttribute('data-cedar-product-id') === PRODUCT_ID;
  }

  function getFormId(form) {
    return form && form.getAttribute('id') || '';
  }

  function productForm() {
    return document.querySelector('product-form.main-product-form form[data-type="add-to-cart-form"][action*="/cart/add"]') ||
      document.querySelector('product-form[data-main="true"] form[data-type="add-to-cart-form"][action*="/cart/add"]') ||
      document.querySelector('form[id^="product-form-"][data-type="add-to-cart-form"][action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"][id^="product-form-"]');
  }

  function stripLegacyFields(form) {
    if (!form) return;
    form.querySelectorAll(
      'input[name="selling_plan"], input[name="selling_plan[]"], ' +
      'input[name="properties[__kaching_bundles]"]'
    ).forEach(function (input) { input.remove(); });
    form.querySelectorAll('[data-selling-plan-id]').forEach(function (node) {
      node.removeAttribute('data-selling-plan-id');
    });
    Array.prototype.slice.call(form.elements || []).forEach(function (control) {
      var name = control.name || '';
      if (/^items\[|^kaching-bundles-deal-/.test(name)) control.disabled = true;
    });
    var formId = getFormId(form);
    if (formId) {
      document.querySelectorAll('[form="' + formId + '"]').forEach(function (control) {
        var name = control.name || '';
        if (/^items\[|^kaching-bundles-deal-/.test(name)) control.disabled = true;
      });
    }
    var isMainProductForm = form.matches('product-form.main-product-form form, product-form[data-main="true"] form') ||
      form.closest('product-form.main-product-form, product-form[data-main="true"]');
    if (isMainProductForm) {
      form.querySelectorAll('input[name="product-id"]').forEach(function (input) {
        input.value = '9599642140899';
      });
      if (onTargetProduct()) {
        document.querySelectorAll('cart-drawer-upsell[data-selected="true"], .cart-drawer-upsell[data-selected="true"]')
          .forEach(function (upsell) {
            /* These copied upsells were serialized as preselected line items by main.js. They may
               still be offered from the cart drawer, but must never be silently added with the main
               product. */
            upsell.dataset.selected = 'false';
            upsell.classList.remove('selected', 'active', 'upsell--selected');
          });
      }
    }
    form.querySelectorAll('.kaching-bundles__subscriptions-wrapper, .kaching-bundles__subscriptions, .kaching-bundles__subscription')
      .forEach(function (node) { node.remove(); });
    form.querySelectorAll('kaching-bundles-block').forEach(function (block) {
      try {
        var config = JSON.parse(block.getAttribute('config') || '{}');
        config.includeSellingPlans = false;
        config.subscriptionsEnabled = false;
        config.subscribeByDefault = false;
        if (config.featureFlags) config.featureFlags.observe_form_selling_plan = false;
        block.setAttribute('config', JSON.stringify(config));
        var product = JSON.parse(block.getAttribute('product') || '{}');
        product.sellingPlans = [];
        (product.variants || []).forEach(function (variant) { variant.sellingPlans = []; });
        block.setAttribute('product', JSON.stringify(product));
      } catch (error) {
        /* The static app markup is optional; the native form guard still applies if it is not JSON. */
      }
    });
    form.dataset.cedarOneTime = '1';
  }

  /* Dawn's sticky-atc element only mirrors the main button's visibility. Its
     button is type=button and the copied theme does not wire it to the native
     ProductForm submit handler, so it becomes a visible no-op. Delegate the
     click to the existing native form and let ProductForm render the drawer.
     This keeps one Shopify cart path for both the in-page and sticky buttons. */
  function bindStickyAtc(form) {
    var formId = getFormId(form);
    if (!formId) return;
    var buttons = document.querySelectorAll('sticky-atc button[form]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.getAttribute('form') !== formId || button.dataset.cedarStickyAtcBound) return;
      button.dataset.cedarStickyAtcBound = '1';
      button.addEventListener('click', function (event) {
        if (button.disabled) return;
        event.preventDefault();
        stripLegacyFields(form);
        var submitter = form.querySelector('button[type="submit"], input[type="submit"]');
        if (typeof form.requestSubmit === 'function') {
          if (submitter && !submitter.disabled) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else if (submitter) {
          submitter.click();
        }
      });
    });
  }

  /* ProductForm already replaces and opens the cart drawer from the bundled
     section response. The copied theme also asks cart-drawer-items to refresh
     itself from a non-existent `main-cart-items` section after every cart
     event. That redundant request returns an empty 404 page and the legacy
     handler then dereferences a missing <cart-items> node. Skip only that
     duplicate drawer refresh on this product; the native ProductForm remains
     the single owner of the successful drawer render. */
  function guardLegacyDrawerRefresh() {
    var DrawerItems = window.customElements && window.customElements.get('cart-drawer-items');
    if (!DrawerItems || !DrawerItems.prototype || DrawerItems.prototype.cedarNativeRenderGuard) return;
    var original = DrawerItems.prototype.onCartUpdate;
    if (typeof original !== 'function') return;
    DrawerItems.prototype.onCartUpdate = function () {
      if (onTargetProduct()) return;
      return original.apply(this, arguments);
    };
    DrawerItems.prototype.cedarNativeRenderGuard = true;
  }

  function variantIdForBar(bar) {
    if (!bar) return '';
    var explicit = bar.getAttribute('data-variant-id') ||
      (bar.querySelector('[data-variant-id]') || {}).getAttribute &&
      bar.querySelector('[data-variant-id]').getAttribute('data-variant-id');
    if (explicit && VARIANTS[explicit]) return explicit;
    var titleNode = bar.querySelector('.kaching-bundles__bar-title');
    var title = (titleNode && titleNode.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!title) return '';
    if (title.indexOf('habit tracker + task tracker') !== -1 ||
        title.indexOf('task + habit tracker') !== -1) return '49522223251683';
    if (title === 'task tracker') return '49522223186147';
    if (title === 'habit tracker') return '49522223218915';
    return '';
  }

  function updateDisplayedPrices(id) {
    var values = VARIANTS[String(id)];
    if (!values) return;
    document.querySelectorAll(
      '.price__sale .price-item--sale, .price__regular .price-item--regular, ' +
      '.quantity-break__price'
    ).forEach(function (node) { node.textContent = values.price; });
    document.querySelectorAll('.kaching-bundles__bar-price').forEach(function (node) {
      var bar = node.closest('.kaching-bundles__bar');
      var barId = variantIdForBar(bar);
      var barValues = VARIANTS[barId] || values;
      node.textContent = bar ? barValues.price : values.price;
    });
    document.querySelectorAll(
      '.price__compare-price .price-item--regular, .quantity-break__compare-price, ' +
      '.kaching-bundles__bar-full-price'
    ).forEach(function (node) {
      var bar = node.closest('.kaching-bundles__bar');
      var barId = variantIdForBar(bar);
      var barValues = VARIANTS[barId] || values;
      node.textContent = bar ? barValues.compare : values.compare;
    });
    document.querySelectorAll('select[name="id"] option').forEach(function (option) {
      var optionValues = VARIANTS[option.value];
      if (!optionValues) return;
      option.textContent = option.textContent.replace(/\s+-\s+\$[0-9.]+$/, '') + ' - ' + optionValues.price;
    });
  }

  function syncVariant(id) {
    var form = productForm();
    if (!form || !VARIANTS[String(id)]) return;
    var input = form.querySelector('input[name="id"], select[name="id"]');
    if (input) {
      input.value = String(id);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var title = id === '49522223186147' ? 'Task Tracker' :
      id === '49522223218915' ? 'Habit Tracker' : 'Task + Habit Tracker';
    var controls = Array.prototype.slice.call(form.elements || []);
    var formId = getFormId(form);
    if (formId) {
      controls = controls.concat(Array.prototype.slice.call(document.querySelectorAll('[form="' + formId + '"]')));
    }
    var seen = [];
    controls.forEach(function (control) {
      if (!control || seen.indexOf(control) !== -1) return;
      seen.push(control);
      if (control.name === 'options[Choose Version]') {
        control.value = title;
      } else if (control.name === 'Choose Version' && control.type === 'radio') {
        var label = (control.value || '').replace(/\s+/g, ' ').trim();
        control.checked = label === title;
      }
    });
    stripLegacyFields(form);
    updateDisplayedPrices(id);
    form.dataset.cedarVariantSynced = String(id);
  }

  function closestBundleBar(node) {
    while (node && node !== document) {
      if (node.classList && node.classList.contains('kaching-bundles__bar')) return node;
      node = node.parentNode;
    }
    return null;
  }

  function init() {
    if (!onTargetProduct()) return;
    guardLegacyDrawerRefresh();
    var form = productForm();
    if (!form) return;
    stripLegacyFields(form);
    bindStickyAtc(form);
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var barVariantId = variantIdForBar(bar);
      if (barVariantId) bar.setAttribute('data-variant-id', barVariantId);
    });
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput && form.dataset.cedarVariantSynced !== String(idInput.value)) syncVariant(idInput.value);
    if (!form.dataset.cedarOneTimeBound) {
      form.dataset.cedarOneTimeBound = '1';
      form.addEventListener('submit', function () {
        stripLegacyFields(form);
        form.dataset.cedarAddInFlight = '1';
      }, true);
      new MutationObserver(function () { stripLegacyFields(form); }).observe(form, {
        childList: true,
        subtree: true
      });
    }
    if (!document.documentElement.dataset.cedarOneTimeClicks) {
      document.documentElement.dataset.cedarOneTimeClicks = '1';
      document.addEventListener('click', function (event) {
        var bar = closestBundleBar(event.target);
        var id = variantIdForBar(bar);
        if (id) syncVariant(id);
      }, true);
      document.addEventListener('submit', function (event) {
        var targetForm = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]');
        if (targetForm) stripLegacyFields(targetForm);
      }, true);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var n = 0, iv = setInterval(function () { init(); if (++n > 20) clearInterval(iv); }, 500);
})();

(function () {
  function onTargetProduct() {
    return document.body && document.body.dataset.cedarProductId === '9599642140899';
  }

  function syncDrawerAccessibility(drawer, isOpen) {
    if (!drawer || !onTargetProduct()) return;
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) drawer.removeAttribute('inert');
    else drawer.setAttribute('inert', '');
  }

  function isUsableDrawerOpener(drawer, node) {
    return !!(node && node.nodeType === 1 && node.isConnected &&
      node !== document.body && node !== document.documentElement &&
      !drawer.contains(node) && typeof node.focus === 'function');
  }

  function settleTargetAddToCartState() {
    if (!onTargetProduct()) return;
    document.querySelectorAll(
      'product-form.main-product-form form[data-type="add-to-cart-form"], ' +
      'product-form[data-main="true"] form[data-type="add-to-cart-form"]'
    ).forEach(function (form) {
      if (form.dataset.cedarAddInFlight !== '1') return;
      var button = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!button) return;
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      var spinner = button.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
      var requiredFields = Number(button.dataset.requiredFields || 0);
      var validFields = Number(button.dataset.validFields || 0);
      if (button.dataset.unavailable !== 'true' && validFields >= requiredFields) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
      document.querySelectorAll('sticky-atc button[form="' + form.getAttribute('id') + '"]')
        .forEach(function (stickyButton) {
          stickyButton.classList.remove('loading');
          stickyButton.removeAttribute('aria-busy');
          if (!button.disabled && button.getAttribute('aria-disabled') !== 'true') {
            stickyButton.disabled = false;
            stickyButton.removeAttribute('aria-disabled');
          }
        });
      delete form.dataset.cedarAddInFlight;
    });
  }

  function installCartSectionGuard() {
    var CartDrawer = window.customElements && window.customElements.get('cart-drawer');
    if (!CartDrawer || !CartDrawer.prototype) return;
    var prototype = CartDrawer.prototype;

    if (!prototype.cedarNullSectionGuard) {
      var renderContents = prototype.renderContents;
      if (typeof renderContents === 'function') {
        prototype.cedarNullSectionGuard = true;
        prototype.renderContents = function (cartData) {
          if (cartData && cartData.sections && cartData.sections['cart-icon-bubble'] == null) {
            var cartIcon = document.getElementById('cart-icon-bubble');
            cartData.sections['cart-icon-bubble'] = '<div class="shopify-section">' +
              (cartIcon ? cartIcon.innerHTML : '') + '</div>';
          }
          try {
            return renderContents.call(this, cartData);
          } finally {
            if (onTargetProduct()) {
              settleTargetAddToCartState();
              requestAnimationFrame(settleTargetAddToCartState);
            }
          }
        };
      }
    }

    if (!prototype.cedarAccessibilityGuard &&
        typeof prototype.open === 'function' &&
        typeof prototype.close === 'function') {
      var nativeOpen = prototype.open;
      var nativeClose = prototype.close;
      prototype.cedarAccessibilityGuard = true;
      prototype.open = function () {
        if (!onTargetProduct()) return nativeOpen.apply(this, arguments);
        var openArguments = Array.prototype.slice.call(arguments);
        if (!isUsableDrawerOpener(this, openArguments[0])) {
          if (isUsableDrawerOpener(this, document.activeElement)) {
            openArguments[0] = document.activeElement;
          } else if (isUsableDrawerOpener(this, this.activeElement)) {
            openArguments[0] = this.activeElement;
          } else {
            var cartIcon = document.getElementById('cart-icon-bubble');
            if (isUsableDrawerOpener(this, cartIcon)) openArguments[0] = cartIcon;
          }
        }
        syncDrawerAccessibility(this, true);
        var result = nativeOpen.apply(this, openArguments);
        settleTargetAddToCartState();
        return result;
      };
      prototype.close = function () {
        if (!onTargetProduct()) return nativeClose.apply(this, arguments);
        var result = nativeClose.apply(this, arguments);
        syncDrawerAccessibility(this, false);
        return result;
      };
    }

    if (onTargetProduct()) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) syncDrawerAccessibility(drawer, drawer.classList.contains('active'));
    }
  }

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('cart-drawer').then(installCartSectionGuard);
  }
  installCartSectionGuard();
})();

/* Digital cart-line guard. These variants are instant-download products and must stay at
   one unit in a cart. The Liquid section marks them explicitly, while this guard survives
   Shopify's bundled section replacements and protects the native quantity change event. */
(function () {
  var DIGITAL_VARIANTS = {
    '49522223186147': true,
    '49522223218915': true,
    '49522223251683': true,
    '49522224005347': true,
    '49522223972579': true,
    '49522223415523': true,
    '49522223382755': true,
    '49522223317219': true,
    '49522223349987': true
  };
  var normalizing = Object.create(null);

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  }

  function isDigitalLineId(id) {
    var value = String(id || '');
    if (DIGITAL_VARIANTS[value]) return true;
    return Array.prototype.some.call(document.querySelectorAll('.cart-item[data-digital="true"]'), function (line) {
      return String(line.dataset.key || '') === value;
    });
  }

  function cartMutationKind(path) {
    var pathname = String(path || '').split('?')[0];
    if (/\/cart\/change(?:\.js)?$/.test(pathname)) return 'change';
    if (/\/cart\/update(?:\.js)?$/.test(pathname)) return 'update';
    return '';
  }

  function isTargetCartAdd(path) {
    if (!document.body || document.body.dataset.cedarProductId !== '9599642140899') return false;
    var pathname = String(path || '').split('?')[0];
    return /\/cart\/add(?:\.js)?$/.test(pathname);
  }

  function normalizeTargetCartAddResponse(path, response) {
    if (!isTargetCartAdd(path) || !response) return response;
    var contentType = String(response.headers.get('content-type') || '').toLowerCase();
    if (contentType.indexOf('json') !== -1 || contentType.indexOf('javascript') !== -1) {
      if (!response.ok) scheduleTargetCartAddFailure();
      return response;
    }
    var status = response.status === 429 ? 429 : 502;
    var description = response.status === 429
      ? 'The store is receiving a lot of traffic. Please wait a moment and try again.'
      : 'We could not add this item to your cart. Please try again.';
    scheduleTargetCartAddFailure();
    return new Response(JSON.stringify({ status: status, description: description }), {
      status: status,
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    });
  }

  function scheduleTargetCartAddFailure() {
    setTimeout(function () {
      document.querySelectorAll(
        'product-form.main-product-form form[data-type="add-to-cart-form"], ' +
        'product-form[data-main="true"] form[data-type="add-to-cart-form"]'
      ).forEach(function (form) {
        var button = form.querySelector('button[type="submit"], input[type="submit"]');
        if (button) {
          button.classList.remove('loading');
          button.removeAttribute('aria-busy');
          var spinner = button.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
          var requiredFields = Number(button.dataset.requiredFields || 0);
          var validFields = Number(button.dataset.validFields || 0);
          if (button.dataset.unavailable !== 'true' && validFields >= requiredFields) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        }
        document.querySelectorAll('sticky-atc button[form="' + form.getAttribute('id') + '"]')
          .forEach(function (stickyButton) {
            stickyButton.classList.remove('loading');
            stickyButton.removeAttribute('aria-busy');
            if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
              stickyButton.disabled = false;
              stickyButton.removeAttribute('aria-disabled');
            }
          });
        delete form.dataset.cedarAddInFlight;
      });
    }, 0);
  }

  function bodyValue(parsed, mode, key) {
    if (!parsed) return null;
    return mode === 'params' || mode === 'form' ? parsed.get(key) : parsed[key];
  }

  function isDigitalChangeTarget(parsed, mode) {
    var id = bodyValue(parsed, mode, 'id');
    if (id != null && isDigitalLineId(id)) return true;
    var lineIndex = bodyValue(parsed, mode, 'line');
    if (lineIndex == null) return false;
    var line = Array.prototype.find.call(document.querySelectorAll('.cart-item[data-index]'), function (node) {
      return String(node.dataset.index) === String(lineIndex);
    });
    return !!line && (line.dataset.digital === 'true' || DIGITAL_VARIANTS[String(line.dataset.variantId || '')]);
  }

  function clampMutationBody(path, body) {
    var kind = cartMutationKind(path);
    var parsed = body;
    var mode = 'object';
    if (typeof body === 'string') {
      try {
        parsed = JSON.parse(body);
        mode = 'json';
      } catch (error) {
        parsed = new URLSearchParams(body);
        mode = 'params';
      }
    } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      mode = 'params';
    } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
      mode = 'form';
    }
    var changed = false;
    if (kind === 'change') {
      var changeQuantity = Number(bodyValue(parsed, mode, 'quantity'));
      if (isDigitalChangeTarget(parsed, mode) && changeQuantity > 1) {
        if (mode === 'params' || mode === 'form') parsed.set('quantity', '1');
        else parsed.quantity = 1;
        changed = true;
      }
    } else if (kind === 'update') {
      var updates = parsed && parsed.updates;
      if (updates && typeof updates === 'object' && !Array.isArray(updates)) {
        Object.keys(updates).forEach(function (id) {
          if (isDigitalLineId(id) && Number(updates[id]) > 1) {
            updates[id] = 1;
            changed = true;
          }
        });
      } else if (mode === 'params' || mode === 'form') {
        var lines = Array.prototype.slice.call(document.querySelectorAll('.cart-item'));
        var values = parsed.getAll('updates[]');
        lines.forEach(function (line, index) {
          if (line.dataset.digital !== 'true' || Number(values[index]) <= 1) return;
          values[index] = '1';
          changed = true;
        });
        if (changed) {
          parsed.delete('updates[]');
          values.forEach(function (value) { parsed.append('updates[]', String(value)); });
        }
      }
    }
    if (!changed) return body;
    if (mode === 'json') return JSON.stringify(parsed);
    return parsed;
  }

  function installCartMutationGuard() {
    if (window.__cedarCartMutationGuard) return;
    window.__cedarCartMutationGuard = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      var requestInit = init;
      if (requestInit && requestInit.body && cartMutationKind(requestUrl)) {
        requestInit = Object.assign({}, requestInit, {
          body: clampMutationBody(requestUrl, requestInit.body)
        });
      }
      return nativeFetch.call(this, input, requestInit).then(function (response) {
        return normalizeTargetCartAddResponse(requestUrl, response);
      }, function (error) {
        if (!isTargetCartAdd(requestUrl)) throw error;
        scheduleTargetCartAddFailure();
        return new Response(JSON.stringify({
          status: 503,
          description: 'We could not add this item to your cart. Please check your connection and try again.'
        }), {
          status: 503,
          headers: { 'Content-Type': 'application/json; charset=utf-8' }
        });
      });
    };
  }

  function digitalLine(node) {
    var line = node && node.closest && node.closest('.cart-item[data-digital="true"], [data-digital="true"]');
    if (line) return line;
    var variant = node && node.closest && node.closest('.cart-item');
    return variant && DIGITAL_VARIANTS[String(variant.dataset.variantId || '')] ? variant : null;
  }

  function normalizeDigitalLine(line) {
    var key = line && line.dataset.key;
    var quantity = Number(line && line.dataset.quantity || 0);
    if (!key || quantity <= 1 || normalizing[key]) return;
    normalizing[key] = true;
    var body = JSON.stringify({
      id: key,
      quantity: 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });
    fetch(shopifyRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: body
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (data) {
      var drawer = document.querySelector('cart-drawer');
      if (data && data.sections && drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      }
    }).catch(function () {
      /* The native drawer remains usable if a legacy cart line cannot be normalized. */
    }).finally(function () {
      delete normalizing[key];
    });
  }

  function applyDigitalQuantityGuards() {
    document.querySelectorAll('.cart-item[data-digital="true"], .cart-item').forEach(function (line) {
      var isDigital = line.dataset.digital === 'true' || DIGITAL_VARIANTS[String(line.dataset.variantId || '')];
      if (!isDigital) return;
      line.dataset.digital = 'true';
      line.dataset.maxQuantity = '1';
      var input = line.querySelector('.quantity__input');
      if (input) {
        input.setAttribute('max', '1');
        input.setAttribute('min', '1');
        input.value = '1';
        input.readOnly = true;
        input.setAttribute('aria-readonly', 'true');
      }
      line.querySelectorAll('.quantity__button').forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      });
      normalizeDigitalLine(line);
    });
  }

  function install() {
    if (document.documentElement.dataset.cedarDigitalQuantityGuard) return;
    document.documentElement.dataset.cedarDigitalQuantityGuard = '1';
    installCartMutationGuard();
    document.addEventListener('input', function (event) {
      var line = digitalLine(event.target);
      if (!line) return;
      event.target.value = '1';
    }, true);
    document.addEventListener('change', function (event) {
      var line = digitalLine(event.target);
      if (!line) return;
      event.target.value = '1';
      applyDigitalQuantityGuards();
    }, true);
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.quantity__button');
      if (!button || !digitalLine(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    var observer = new MutationObserver(applyDigitalQuantityGuards);
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    applyDigitalQuantityGuards();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
})();

/* Cedar minimal behaviour for the kaching-bundles widget (visual + selection).
   The app's own JS drove selection/cart; we don't run it. This makes the bars selectable and
   keeps the theme's real variant in sync so ADD TO CART adds the chosen version. Idempotent. */
(function () {
  function init() {
    var widget = document.querySelector('.kaching-bundles');
    if (!widget || widget.dataset.cedarKaching) return;
    var bars = widget.querySelectorAll('.kaching-bundles__bar');
    if (!bars.length) return;
    widget.dataset.cedarKaching = '1';

    function selectBar(bar) {
      bars.forEach(function (b) { b.classList.remove('kaching-bundles__bar--selected'); });
      bar.classList.add('kaching-bundles__bar--selected');
      // sync the theme's real variant picker if this bar names a variant id
      var vid = bar.getAttribute('data-variant-id') ||
                (bar.querySelector('[data-variant-id]') || {}).getAttribute &&
                bar.querySelector('[data-variant-id]').getAttribute('data-variant-id');
      if (!vid) return;
      var form = bar.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var input = form.querySelector('input[name="id"], select[name="id"]');
      if (input && String(input.value) !== String(vid)) {
        input.value = vid;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    bars.forEach(function (bar) {
      bar.style.cursor = 'pointer';
      bar.addEventListener('click', function () { selectBar(bar); });
    });
    // Prefer Shopify's selected variant, then the source selection, then the most-popular bar.
    // This keeps visual state, analytics state, and the submitted variant aligned on direct links.
    var form = widget.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"], select[name="id"]');
    var selectedVariant = variantInput && String(variantInput.value || '');
    var targetProduct = document.body && document.body.getAttribute('data-cedar-product-id') === '9599642140899';
    var matchingBar = targetProduct && Array.prototype.find.call(bars, function (bar) {
      return String(bar.getAttribute('data-variant-id') || '') === selectedVariant;
    });
    var pre = matchingBar || widget.querySelector('.kaching-bundles__bar--selected') ||
              (widget.querySelector('.kaching-bundles__bar-most-popular') || {}).closest &&
              widget.querySelector('.kaching-bundles__bar-most-popular').closest('.kaching-bundles__bar');
    selectBar(pre || bars[0]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var n = 0, iv = setInterval(function () { init(); if (++n > 6) clearInterval(iv); }, 800);
})();

/* Keep the legacy section wrapper from breaking Dawn's on-scroll-up header.
   Shopify wraps a legacy section in an extra div; the source theme makes the
   direct body child the sticky section. Rebind the existing custom element to
   that direct wrapper before the first scroll event. */
(function () {
  function repairStickyHeader() {
    var sticky = document.querySelector('sticky-header[data-sticky-type]');
    if (!sticky) return;
    var content = sticky.parentElement;
    var outer = content && content.parentElement;
    if (!outer || !outer.classList.contains('shopify-section')) return;
    content.classList.remove('section-header');
    outer.classList.add('section-header');
    sticky.header = outer;
    var rect = outer.getBoundingClientRect();
    sticky.headerBounds = { top: rect.top, bottom: rect.bottom };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repairStickyHeader);
  else repairStickyHeader();
})();

/* --- Ako 2026-08-12 ---
   1) The "Save 20% - Join Quiet Progress" upsell is no longer offered — remove it outright.
   2) Flash-sale badge redesign. The app renders ONE text node
      ("FLASH SALE - OFFER ENDS IN 20:13:12 ⏰") in a solid BLACK bar, which fought the black
      ADD TO CART for attention (his words). Split it into a label + a monospace countdown pill so
      it can be styled as a light, brand-tinted urgency strip and the ATC button stays the only
      heavy black element on the page. */
(function () {
  function dropUpsell() {
    document.querySelectorAll('.kaching-bundles *').forEach(function (e) {
      if (e.dataset.cedarChecked) return;
      var txt = (e.textContent || '').trim();
      if (/^Save 20%/.test(txt) && txt.length < 220 && e.querySelector('input,svg,[class*=check]')) {
        var row = e.closest('.kaching-bundles__bar') || e;
        row.dataset.cedarChecked = '1';
        row.remove();
      }
    });
    // also catch the plain wrapper form of the same row
    document.querySelectorAll('.kaching-bundles__upsell, .kaching-bundles__subscription')
      .forEach(function (e) { e.remove(); });
  }

  function dressTimer() {
    var t = document.querySelector('.kaching-bundles__timer-title');
    if (!t || t.dataset.cedarTimer) return;
    var raw = (t.textContent || '').replace(/[\u23F0\u231A\u23F1\uFE0F]/g, '').trim();
    var m = raw.match(/(\d{1,2}:\d{2}(?::\d{2})?)/);
    if (!m) return;
    var label = raw.slice(0, m.index).replace(/[-–—:]\s*$/, '').trim();
    t.dataset.cedarTimer = '1';
    t.innerHTML = '';
    var l = document.createElement('span');
    l.className = 'cedar-fs__label';
    l.textContent = label || 'Flash sale ends in';
    var v = document.createElement('span');
    v.className = 'cedar-fs__time';
    v.textContent = m[1];
    t.appendChild(l); t.appendChild(v);
    /* The app's own rule group `[class*=kaching][class*=timer]` matches BOTH the strip and its
       title, so the 12px padding kept winning the cascade twice over (measured 70px tall — as
       tall as an option card, which is exactly what Ako said made it look like another button).
       Set the slim box inline with !important: nothing in a stylesheet can outrank that. */
    var outer = t.closest('.kaching-bundles__timer') || t.parentElement;
    if (outer) {
      outer.style.setProperty('padding', '8px 12px', 'important');
      outer.style.setProperty('min-height', '0', 'important');
      outer.style.setProperty('border-radius', '10px', 'important');
    }
    t.style.setProperty('padding', '0', 'important');
    t.style.setProperty('height', '22px', 'important');
    t.style.setProperty('min-height', '0', 'important');
    // keep the live countdown ticking: the app rewrites textContent, so re-dress on change
    new MutationObserver(function () {
      var txt = (t.textContent || '').match(/(\d{1,2}:\d{2}(?::\d{2})?)/);
      if (txt && v.textContent !== txt[1]) v.textContent = txt[1];
    }).observe(t, { childList: true, characterData: true, subtree: true });
  }

  function slim() {
    var t = document.querySelector('.kaching-bundles__timer');
    var ti = t && t.querySelector('.kaching-bundles__timer-title');
    if (!t || !ti) return;
    t.style.setProperty('padding', '8px 12px', 'important');
    t.style.setProperty('min-height', '0', 'important');
    t.style.setProperty('border-radius', '10px', 'important');
    ti.style.setProperty('padding', '0', 'important');
    ti.style.setProperty('height', '22px', 'important');
    ti.style.setProperty('min-height', '0', 'important');
  }

  function run() { dropUpsell(); dressTimer(); slim(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* The app re-renders the countdown node every tick, wiping inline styles — a bounded retry let
     the strip snap back to 70px (as tall as an option card). Watch permanently instead. */
  var host = document.querySelector('.kaching-bundles') || document.body;
  new MutationObserver(function () { run(); }).observe(host, { childList: true, subtree: true });
  var n = 0, iv = setInterval(function () { run(); if (++n > 20) clearInterval(iv); }, 500);
})();
